import React from 'react';
import { 
  Card, 
  Table, 
 
 
  Space, 
  Typography, 
  Tag, 



  Avatar
} from 'antd';
import { 
  CreditCardOutlined,

  BankOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';
import { useAccount } from '../../context/AccountContext';
import type { ColumnsType } from 'antd/es/table';

const { Title, Text } = Typography;

interface BankCard {
  id: string;
  bind_acct_no: string;
  bind_acct_no_acct_nme: string;
  bind_acct_bank_nme: string;
  bind_acct_bank_no: string;
  our_bank_othr_bank_flg: '0' | '1';
  bind_sts: '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8';
  bind_acc_sts: '0' | '1' | '2';
  manager_approver_sts: '0' | '1' | '2' | '3' | '4' | '5' | '6';
  status: 'pending' | 'verified' | 'failed';
  bindTime: string;
}

const CardManagement: React.FC = () => {
  const { accountStatus, updateAccountStatus } = useAccount();





  // 表格列定义
  const columns: ColumnsType<BankCard> = [
    {
      title: '银行信息',
      key: 'bank',
      render: (_, record) => (
        <Space>
          <Avatar icon={<BankOutlined />} size="large" />
          <div>
            <div style={{ fontWeight: 500 }}>{record.bind_acct_bank_nme}</div>
            <Text type="secondary" style={{ fontSize: '12px' }}>
              {record.bind_acct_bank_no}
            </Text>
          </div>
        </Space>
      ),
    },
    {
      title: '卡号',
      dataIndex: 'bind_acct_no',
      key: 'bind_acct_no',
      render: (bind_acct_no: string) => (
        <Text style={{ fontFamily: 'monospace' }}>
          **** **** **** {bind_acct_no.slice(-4)}
        </Text>
      ),
    },
    {
      title: '户名',
      dataIndex: 'bind_acct_no_acct_nme',
      key: 'bind_acct_no_acct_nme',
    },
    {
      title: '绑定状态',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => {
        const statusMap = {
          pending: { color: 'orange', text: '待验证', icon: <ClockCircleOutlined /> },
          verified: { color: 'green', text: '已验证', icon: <CheckCircleOutlined /> },
          failed: { color: 'red', text: '验证失败', icon: <ExclamationCircleOutlined /> },
        };
        const config = statusMap[status as keyof typeof statusMap];
        return (
          <Tag color={config.color} icon={config.icon}>
            {config.text}
          </Tag>
        );
      },
    },
    {
      title: '绑定时间',
      dataIndex: 'bindTime',
      key: 'bindTime',
      render: (time: string) => new Date(time).toLocaleString(),
    },

  ];

  // 初始化数据 - 使用模拟数据
  React.useEffect(() => {
    if (!accountStatus.cardInfo || accountStatus.cardInfo.length === 0) {
      const mockCardData: BankCard[] = [
        {
          id: '1',
          bind_acct_no: '6222021001123456789',
          bind_acct_no_acct_nme: '上海数据交易所有限公司',
          bind_acct_bank_nme: '工商银行',
          bind_acct_bank_no: '102100099996',
          our_bank_othr_bank_flg: '1',
          bind_sts: '1', // 正常
          bind_acc_sts: '1', // 可用
          manager_approver_sts: '2', // 客户经理审批通过
          status: 'verified',
          bindTime: '2024-01-15T10:30:00Z'
        },
        {
          id: '2',
          bind_acct_no: '6228480402564890013',
          bind_acct_no_acct_nme: '上海数据交易所有限公司',
          bind_acct_bank_nme: '农业银行',
          bind_acct_bank_no: '103100000026',
          our_bank_othr_bank_flg: '1',
          bind_sts: '2', // 入金激活待确认
          bind_acc_sts: '0', // 流程中
          manager_approver_sts: '1', // 客户经理审批流程中
          status: 'pending',
          bindTime: '2024-01-20T14:20:00Z'
        },
        {
          id: '3',
          bind_acct_no: '6013821200012345678',
          bind_acct_no_acct_nme: '上海数据交易所有限公司',
          bind_acct_bank_nme: '中国银行',
          bind_acct_bank_no: '104100000004',
          our_bank_othr_bank_flg: '1',
          bind_sts: '7', // 验证失败
          bind_acc_sts: '2', // 不可用
          manager_approver_sts: '3', // 客户经理审批拒绝
          status: 'failed',
          bindTime: '2024-01-18T09:15:00Z'
        },
        {
          id: '4',
          bind_acct_no: '6227000012345678901',
          bind_acct_no_acct_nme: '上海数据交易所有限公司',
          bind_acct_bank_nme: '建设银行',
          bind_acct_bank_no: '105100000017',
          our_bank_othr_bank_flg: '1',
          bind_sts: '3', // 待出金验证
          bind_acc_sts: '0', // 流程中
          manager_approver_sts: '4', // 网银审批流程中
          status: 'pending',
          bindTime: '2024-01-22T16:45:00Z'
        },
        {
          id: '5',
          bind_acct_no: '6225882112345678',
          bind_acct_no_acct_nme: '上海数据交易所有限公司',
          bind_acct_bank_nme: '招商银行',
          bind_acct_bank_no: '310290000013',
          our_bank_othr_bank_flg: '1',
          bind_sts: '4', // 出金待确认
          bind_acc_sts: '0', // 流程中
          manager_approver_sts: '5', // 网银审批通过
          status: 'pending',
          bindTime: '2024-01-25T11:30:00Z'
        },
        {
          id: '6',
          bind_acct_no: '6226220012345678',
          bind_acct_no_acct_nme: '上海数据交易所有限公司',
          bind_acct_bank_nme: '民生银行',
          bind_acct_bank_no: '301584007998',
          our_bank_othr_bank_flg: '1',
          bind_sts: '5', // 出金失败
          bind_acc_sts: '2', // 不可用
          manager_approver_sts: '6', // 网银审批拒绝
          status: 'failed',
          bindTime: '2024-01-28T15:20:00Z'
        },
        {
          id: '7',
          bind_acct_no: '622260011234567890',
          bind_acct_no_acct_nme: '上海数据交易所有限公司',
          bind_acct_bank_nme: '交通银行',
          bind_acct_bank_no: '301290000007',
          our_bank_othr_bank_flg: '1',
          bind_sts: '8', // 入金激活次数超限或超时
          bind_acc_sts: '2', // 不可用
          manager_approver_sts: '3', // 客户经理审批拒绝
          status: 'failed',
          bindTime: '2024-01-30T09:45:00Z'
        }
      ];
      
      updateAccountStatus({ cardInfo: mockCardData });
    }
  }, [accountStatus.cardInfo, updateAccountStatus]);








  return (
    <div className="page-container">
      <div style={{ marginBottom: 24 }}>
        <Title level={2} style={{ margin: 0 }}>
          <CreditCardOutlined style={{ marginRight: 12, color: '#1890ff' }} />
          银行卡管理
        </Title>
      </div>

      {/* 页面说明（精简） */}
      <div style={{ marginBottom: 24 }}>
        <Text type="secondary" style={{ display: 'block' }}>
          查看企业绑定的银行卡信息。
        </Text>
      </div>

      {/* 银行卡列表 */}
      <Card>
        <Table
          columns={columns}
          dataSource={accountStatus.cardInfo || []}
          rowKey="id"
          locale={{
            emptyText: (
              <div style={{ padding: '40px 0', textAlign: 'center' }}>
                <CreditCardOutlined style={{ fontSize: 48, color: '#d9d9d9', marginBottom: 16 }} />
                <div>
                  <Text type="secondary">暂无绑定的银行卡</Text>
                </div>
              </div>
            )
          }}
        />
      </Card>


    </div>
  );
};

export default CardManagement;